import { useNavigate } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function PaymentCancel() {
  const nav = useNavigate();
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#FAF9F4] flex flex-col items-center justify-center p-6" data-testid="payment-cancel-page">
      <Logo size={28} />
      <div className="mt-12 max-w-md text-center">
        <h1 className="font-[Fraunces] text-4xl">{t("no_worries")}</h1>
        <p className="mt-3 text-neutral-500">{t("card_not_charged")}</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Button variant="outline" onClick={() => nav("/app/projects")} className="rounded-full">{t("back_to_dashboard")}</Button>
          <Button onClick={() => nav("/app/billing")} className="bg-black hover:bg-neutral-800 rounded-full">{t("try_again")}</Button>
        </div>
      </div>
    </div>
  );
}
